/**
 * Talala API Gateway
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * An enumeration.
 */
export type Rarity =
  | 'starting'
  | 'smart'
  | 'simple'
  | 'rare'
  | 'unique'
  | 'epic'
  | 'legendary';

export const Rarity = {
  Starting: 'starting' as Rarity,
  Smart: 'smart' as Rarity,
  Simple: 'simple' as Rarity,
  Rare: 'rare' as Rarity,
  Unique: 'unique' as Rarity,
  Epic: 'epic' as Rarity,
  Legendary: 'legendary' as Rarity,
};
